import {
  //FtBtnBox,
  InspectResultBox,
  InspectResultContainer,
  NoiseResultBox,
  SensitivityResulBox,
  SensitivityResultSubBox,
} from "style/inspect";
import InspectResultHeader from "./inspect.result.header";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getResultsFromType } from "utils/inspect.util";
import { useEffect } from "react";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useRecoilState } from "recoil";
import InspectShareBox from "components/inspect/items/inspect.share.box";
import { inspectClipboardToastStatus } from "atoms/inspect.state";

const InspectResultPreviewDetail = () => {
  const { id } = useParams<{ id: string }>();
  const { sensitivityResult, noiseResult } = getResultsFromType(Number(id))!;
  const accessToken = localStorage.getItem("accessToken");
  const location = useLocation();
  const navigate = useNavigate();
  const fromPage = location.state?.from;

  // 복사 토스트 상태값
  const [clipboard, setClipboard] = useRecoilState(inspectClipboardToastStatus);

  useEffect(() => {
    if (clipboard) {
      loadToast();
      setClipboard(false);
    }
  }, [clipboard]);

  const loadToast = () => {
    toast(`공유링크가 복사되었습니다.`, {
      position: "bottom-center",
      style: {
        backgroundColor: "rgba(0,0,0,0.83)",
        color: "#fff",
        fontSize: "1.2rem",
        borderRadius: "1rem",
        fontWeight: "500",
        letterSpacing: "-0.06rem",
        justifyContent: "center",
        padding: "0.8rem",
        minHeight: "auto",
        boxShadow: "1px 1px 4px 0 #0000004D",
      },
      transition: Slide,
    });
  };

  return (
    <InspectResultContainer>
      <InspectResultHeader
        backPath={
          fromPage === "inspectList"
            ? "/inspect/simple/result/list"
            : "/inspect"
        }
      />
      <InspectResultBox>
        <SensitivityResulBox>
          <div className="title">
            <span>나와 닮은 동물은</span>
            <h3>{sensitivityResult?.title}</h3>
          </div>
          <div className="img-box">
            <img src={sensitivityResult?.imgPath} alt="" />
          </div>
          <div className="content-box">
            <p>{sensitivityResult?.description}</p>
          </div>
        </SensitivityResulBox>
        <SensitivityResultSubBox>
          <p>집에서 들리는 소음을 측정해보세요</p>
          <div className="measure-box">{sensitivityResult?.contents}</div>
        </SensitivityResultSubBox>
        <NoiseResultBox>
          <p>내 귀는 어떤 소리에 더 예민할까?</p>
          <div className="noise-box">{`주파수대에 따른 상대적인 청감 민감도(등청감곡선) 검사 결과, 당신은 ${noiseResult?.contents}`}</div>
        </NoiseResultBox>
        {accessToken && sensitivityResult && (
          <InspectShareBox id={Number(id)} data={sensitivityResult} />
        )}
      </InspectResultBox>
      {/*<FtBtnBox>
        <button
          onClick={() => {
            navigate(`/inspect/simple/step`);
          }}
        >
          테스트 다시하기
        </button>
      </FtBtnBox>*/}

      <ToastContainer
        hideProgressBar
        closeButton={false}
        autoClose={1000}
        style={{
          padding: "1.6rem 3.2rem 4.7rem",
          borderRadius: "1rem",
        }}
      />
    </InspectResultContainer>
  );
};

export default InspectResultPreviewDetail;
